import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4dec16d8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4dec16d8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dec16d8')) {
      api.createRecord('4dec16d8', component.options)
    } else {
      api.reload('4dec16d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4dec16d8", function () {
      api.rerender('4dec16d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/help/index.vue"
export default component.exports